'use client';

import Link from '@eliadmin/core/src/components/link';

import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from '@eliadmin/core/src/components/ui/sheet';

import { HEADER_CONFIG } from '../../constants/header-config';

import { FaRegCircleUser } from 'react-icons/fa6';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export function MemberZoneMobileButton() {
  const me = useCustomerStore(s => s.me);
  const { t } = useTranslations();
  const locale = useLocaleStore(s => s.currentLocale);
  const translatedLabel = t('text2398')?.trim();
  const memberLabel = translatedLabel && translatedLabel !== 'text2398'
    ? translatedLabel
    : locale?.split('-')[0] === 'sk' ? 'Členská zóna' : 'Member zone';

  if (!me)
    return (
      <Link
        prefetch={false}
        href={ROUTES.SIGN_IN()}
        aria-label={memberLabel}
        className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/5"
      >
        <FaRegCircleUser size={20} className="text-primary" />
      </Link>
    );

  return (
    <Sheet>
      <SheetTrigger aria-label={memberLabel} className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/5">
        <FaRegCircleUser size={20} className="text-primary" />
      </SheetTrigger>
      <SheetContent
        side={'bottom'}
        className={cn(
          'ea-member-zone__sheet-content',
          'z-[1001] flex w-full max-w-[800px] flex-col items-start justify-start gap-5 bg-white p-5 sm:max-w-[800px]',
        )}
      >
        {HEADER_CONFIG.memberItems.map((item, index) => {
          const LinkComponent = index === 1 ? 'a' : Link;

          return (
            <SheetClose key={item.label} asChild className="w-full">
              <LinkComponent
                prefetch={false}
                href={item.href()}
                className="flex w-full items-center justify-start gap-2 p-2.5 text-sm text-primary"
              >
                {item.icon}
                {item.label}
              </LinkComponent>
            </SheetClose>
          );
        })}
      </SheetContent>
    </Sheet>
  );
}
